'use client';

import { useEffect, useRef } from 'react';

import { usePathname } from 'next/navigation';
import { usePostHog } from 'posthog-js/react';

// test-exception: side-effect-only client hook (Next.js usePathname + posthog
// capture). The whole body is dedup-via-ref + a posthog.capture call; there is
// no extractable pure logic, and the repo has no renderHook test infra yet.
export default function SharedSurveyPosthogPageviewInner() {
  const posthog = usePostHog();
  const pathname = usePathname();

  const lastPathRef = useRef<string | null>(null);

  useEffect(() => {
    if (!posthog || !pathname) return;
    if (lastPathRef.current === pathname) return;
    lastPathRef.current = pathname;
    posthog.capture('$pageview');
  }, [posthog, pathname]);

  return null;
}
